export const projectsActions = {
    GET_PROJECT_META_DATA: 'GET_PROJECT_META_DATA',
    SET_PROJECT_MEAT_DATA: 'SET_PROJECT_META_DATA',
    GET_PROJECTS: 'GET_PROJECTS',
    SET_PROJECTS: 'SET_PROJECTS',
    GET_PROJECTS_WITH_DEPLOY_STATUS: 'GET_PROJECTS_WITH_DEPLOY_STATUS',
    SET_PROJECTS_WITH_DEPLOY_STATUS: 'SET_PROJECTS_WITH_DEPLOY_STATUS',
    DELETE_PROJECT: 'DELETE_PROJECT',
    DELETE_PROJECT_SUCCESS: 'DELETE_PROJECT_SUCCESS',
    DUPLICATE_PROJECT: 'DUPLICATE_PROJECT',
    DELETE_DRAFT: 'DELETE_DRAFT',
    DELETE_DRAFT_RESP : 'DELETE_DRAFT_RESP',
    GET_CONFLICT_OPTIONS: 'GET_CONFLICT_OPTIONS',
    SET_CONFLICT_OPTIONS: 'SET_CONFLICT_OPTIONS',
    UPDATE_SOURCE_CONTROL: 'UPDATE_SOURCE_CONTROL',
    SET_UPDATE_SOURCE_CONTROL: 'SET_UPDATE_SOURCE_CONTROL',
    GET_RAWDATA: 'GET_ROWDATA',
    SET_RAWDATA: 'SET_ROWDATA'
};

const initState = {
    projectWithMetaData: null,
    projectItems: [],
    projectWithDeployItems: [],
    projectConflictOptions: [],
    projectRawData: null
};

export const projectsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case projectsActions.SET_PROJECT_MEAT_DATA:
            return Object.assign({}, state, { projectWithMetaData : action.payload });

        case projectsActions.SET_PROJECTS:
            return Object.assign({}, state, { projectItems: action.payload });
        case projectsActions.SET_CONFLICT_OPTIONS:
            return Object.assign({}, state, { projectConflictOptions: action.payload });


        case projectsActions.SET_RAWDATA:
            return Object.assign({}, state, { projectRawData: action.payload });            
            


        case projectsActions.SET_UPDATE_SOURCE_CONTROL:
            return Object.assign({}, state, { projectWithDeployItems: action.payload });

            
        case projectsActions.SET_PROJECTS_WITH_DEPLOY_STATUS:
            return Object.assign({}, state, { projectWithDeployItems: action.payload });

        case projectsActions.DELETE_PROJECT_SUCCESS:
            return Object.assign({}, { projectItems: state.projectItems.filter(item => item.id != action.payload.id) });

        case projectsActions.DELETE_DRAFT_RESP:
            break;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/projectsReducer.ts